"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AccordionContext: ()=>AccordionContext,
    AccordionProvider: ()=>AccordionProvider,
    useAccordionContext_unstable: ()=>useAccordionContext_unstable
});
const _reactContextSelector = require("@fluentui/react-context-selector");
const AccordionContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)(undefined);
const accordionContextDefaultValue = {
    openItems: [],
    collapsible: false,
    requestToggle () {
    /* noop */ }
};
const AccordionProvider = AccordionContext.Provider;
const useAccordionContext_unstable = (selector)=>(0, _reactContextSelector.useContextSelector)(AccordionContext, (ctx = accordionContextDefaultValue)=>selector(ctx)); //# sourceMappingURL=AccordionContext.js.map

//# sourceMappingURL=AccordionContext.js.map